var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-popup',{staticClass:"popup-calendar",attrs:{"id":"popup-calendar"}},[_c('f7-view',[_c('f7-page',[_c('Calendar',{on:{"push":_vm.push,"pull":_vm.pull}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }